import { createContext, useContext, useEffect, useState } from "react";

const FavoritesContext = createContext(null);
const CompareContext = createContext(null);
const KF = "je_favorites_v1";
const KC = "je_compare_v1";

export const FavoritesProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KF) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KF, JSON.stringify(ids)); }, [ids]);
  const toggle = (id) => setIds((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const has = (id) => ids.includes(id);
  return <FavoritesContext.Provider value={{ ids, toggle, has, count: ids.length }}>{children}</FavoritesContext.Provider>;
};
export const useFavorites = () => useContext(FavoritesContext);

export const CompareProvider = ({ children }) => {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KC) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KC, JSON.stringify(ids)); }, [ids]);
  const toggle = (id) => setIds((prev) => {
    if (prev.includes(id)) return prev.filter(x => x !== id);
    if (prev.length >= 4) return prev;
    return [...prev, id];
  });
  const has = (id) => ids.includes(id);
  const clear = () => setIds([]);
  return <CompareContext.Provider value={{ ids, toggle, has, clear, count: ids.length }}>{children}</CompareContext.Provider>;
};
export const useCompare = () => useContext(CompareContext);
